import MissingDataNotification from '../MissingDataNotification';

export const Components = {
  MissingDataNotification,
  Notification: MissingDataNotification
};
